import { createAsyncThunk } from '@reduxjs/toolkit'
import * as URLS from 'src/constants/Api'
import client from 'src/utils/client'
import { PublicBooking } from './Type'

// Get BOOKING
export const fetchBooking = createAsyncThunk<PublicBooking, string, { rejectValue: unknown }>(
  'booking/fetchCalendar',
  async (bookingId: string, { rejectWithValue }) => {
    try {
      return await client(URLS.GET_BOOKING(bookingId))
    } catch (err) {
      return rejectWithValue(err)
    }
  }
)

// Delete BOOKING
export const deleteBooking = createAsyncThunk<PublicBooking, string, { rejectValue: unknown }>(
  'booking/deleteCalendar',
  async (applicationId: string, { rejectWithValue }) => {
    try {
      return await client(URLS.GET_APPLICATION_BOOKING(applicationId), {
        method: 'DELETE',
      })
    } catch (err) {
      return rejectWithValue(err)
    }
  }
)

// Update BOOKING
export const updatePublicBooking = createAsyncThunk<
  PublicBooking,
  {
    applicationId: string
    start_date: string
    start_time: string
  },
  { rejectValue: unknown }
>('booking/updateCalendar', async (body, { rejectWithValue }) => {
  try {
    return await client(URLS.GET_APPLICATION_BOOKING(body.applicationId), {
      method: 'POST',
      body,
    })
  } catch (err) {
    return rejectWithValue(err)
  }
})
